<template>
  <detail-page-layout :config="pageConfig" class="dispatch">
    <el-table v-loading="IsLoading" element-loading-text="加载中" :data="[DataForm]">
      <el-table-column label="调度单号" prop="Code"></el-table-column>
      <el-table-column label="物流类型">
        <template scope="prop">
            <el-col>{{prop.row.ShipmentMethod | ShipmentMethod}}</el-col>
        </template>
      </el-table-column>
      <el-table-column label="出库地" prop="SourceWarehouse.Name"></el-table-column>
      <el-table-column label="入库地" prop="DestinationWarehouse.Name"></el-table-column>
      <el-table-column label="调度原因" prop="Notes"></el-table-column>
      <el-table-column label="操作"  v-if="DataForm.State ===  'shipped' && DataForm.ShipmentMethod === 'external'">
        <template scope="scope">
        <el-popover
        ref="popover"
        placement="left"
        width="500"
        trigger="click">
        <el-table :data="ThirdPartyDeliveryInfo" :max-height="300">
          <el-table-column width="180" property="time" label="时间"></el-table-column>
          <el-table-column width="320" property="context" label="物流信息"></el-table-column>
        </el-table>
      </el-popover>
        <el-button v-popover:popover @click="handleGetThirdPartyDeliveryInfo(props.row.Id)" type="text" size="small">查看物流</el-button>
      </template>
      </el-table-column>
    </el-table>
    <h3 style="line-height: 3em;">物料清单</h3>
    <el-table  v-loading="IsLoading" element-loading-text="加载中" :data="DataForm.Lines">
      <el-table-column type="expand" v-if="DataForm.State ===  'verified' || DataForm.State ===  'shipped'">
          <template scope="props">
            <el-form  inline class="demo-table-expand table-data" label-position="top" v-for="item in props.row.LotLines" :key="item.id">
              <el-form-item label="批次号：">
                <span>{{ item.Lot.Code }}</span>
              </el-form-item>
              <el-form-item label="出库地：">
                <span>{{ item.SourceWarehouse.Name }}</span>
              </el-form-item>
              <el-form-item label="发货单：">
                <span>{{ item.OutStockPicking.Code }}</span>
              </el-form-item>
              <el-form-item label="入库地：">
                <span>{{ item.DestinationWarehouse.Name }}</span>
              </el-form-item>
              <el-form-item label="收货单：">
                <span>{{ item.InStockPicking.Code }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      <el-table-column label="物料名称">
        <template scope="props">
            <el-col>{{props.row.Product.Name}}</el-col>
            <el-col>物料编码:{{props.row.Product.Code}}</el-col>
          </template>
      </el-table-column>
      <el-table-column label="品项">
        <template scope="props">
            <el-tag :type="props.row.Condition.Name | ConditionColor">{{props.row.Condition.Name}}</el-tag>
          </template>
      </el-table-column>
      <el-table-column label="品牌" prop="Product.Brand.Name"></el-table-column>
      <el-table-column label="机型" prop="Product.Model.Name"></el-table-column>
      <el-table-column label="模块" prop="Product.Module.Name"></el-table-column>
      <el-table-column label="数量" prop="Quantity"></el-table-column>
    </el-table>
    <div>
    <el-col :span="12" style="margin-top:20px">
      <el-form inline>
        <el-form-item label="物流公司：" v-if="DataForm.State === 'verified' || DataForm.State === 'shipped'">
          <span>{{ DataForm.ExpressCompany.Name }}</span>
        </el-form-item>
        <el-form-item label="物流费用：" v-if="DataForm.State === 'verified'||DataForm.State === 'shipped'">
          <span>{{ DataForm.ShipFee }}元</span>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="12" class="text-right" v-if="DataForm.State === 'verified'" style="margin-top:20px">
      <el-button type="danger" @click="handleCancel()" v-if="DataForm.State !== 'confirmed'">取消</el-button>
      <el-button type="primary" @click="handleApplySend" v-if="DataForm.State !== 'cancelled'">同意</el-button>
    </el-col>
    <el-col :span="12" class="text-right" v-if="DataForm.State === 'confirmed' || DataForm.State === 'created'" style="margin-top:20px">
      <el-button type="danger" @click="handleCancel()" v-if="DataForm.State !== 'cancelled'">取消订单</el-button>
    </el-col>
    </div>
  </detail-page-layout>
</template>

<script>
import DetailPageLayout from '@/components/common/DetailPageLayout'
import o from '@/odata'
export default {
  created() {
    this.getDataForm()
  },
  data() {
    return {
      DataForm: {},
      pageConfig: {
        StepsBarEnabled: true,
        Steps: [
          {key: 'qc', title: '待审核'},
          {key: 'review', title: '待复核'},
          {key: 'finished', title: '已确认'},
        ],
        Step: 1,
        Breadcrumbs: [
          {
            to: {name: 'DispatchOrder'},
            name: '调度单',
          },
          {
            name: '调度单详情',
          },
        ],
      },
      defaultSteps: [
        {key: 'qc', title: '待审核'},
        {key: 'review', title: '待复核'},
        {key: 'finished', title: '已确认'},
      ],
      IsLoading: false,
    }
  },
  methods: {
     /* 获取订单详情 */
    getDataForm() {
      this.IsLoading = true
      const id = this.$route.params.id
      o('ProcurementApOrder').find(id).select(`Id,Code,ShipmentMethod,ProcurementFee,ProcurementType,OrderType,Notes,State,ShipFee`).expand(`ExpressCompany($select=Id,Name,Code),Partner($select=Id,Name),Lines($select=Id,Quantity;$expand=Product,Condition,LotLines($expand=Lot($select=Code),SourceWarehouse($select=Name),DestinationWarehouse($select=Name),OutStockPicking($select=Id,Code),InStockPicking($select=Id,Code))),SourceWarehouse($select=Name,Code),DestinationWarehouse($select=Name,Code)`)
        .get()
        .then(({ data }) => {
          this.IsLoading = false
          this.DataForm = data
          this.updateSteps(data.State)
          // if (data.State === 'confirmed') {
          //   this.pageConfig.Step = 1
          // } else if (data.State === 'finished') {
          //   this.pageConfig.Step = 2
          // }
        }).catch((err) => {
          this.IsLoading = false
          let message
          switch (err.status) {
            case 404:
              message = '订单不存在'
              break
            default:
              message = `unkown error${err.status}`
          }
          this.$alert(message, 'Error!')
        })
    },
    updateSteps(State) {
      switch (State) {
        case 'created':
        case 'confirmed':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 1)
          break
        case 'verified':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 2)
          break
        case 'rechecked':
          this.$set(this.pageConfig, 'Steps', this.defaultSteps)
          this.$set(this.pageConfig, 'Step', 3)
          break
        case 'cancelled':
          this.$set(this.pageConfig, 'Steps', [this.defaultSteps[0], { key: 'fail', title: '已取消', state: 'failure' }])
          this.$set(this.pageConfig, 'Step', 2)
          break
      }
    },
    handleGetThirdPartyDeliveryInfo(id) {
      o(`OutStockPicking(${id})/Services.GetThirdPartyDeliveryInfo()`).get()
      .then(({ data }) => {
        this.ThirdPartyDeliveryInfo = data.data
      })
    },
    handleCancel() {
      this.$confirm('是否确定取消订单', '取消订单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const id = this.$route.params.id
        const form = null
        o(`ProcurementApOrder(${id})/Services.Cancel`).post(form).save().then((response) => {
          this.$message({
            type: 'success',
            message: `取消订单成功`,
          })
          this.getDataForm()
        })
      })
    },
    lowStock(err) {
      this.$confirm(err.message + ',请等待库存满足需求后进行确认订单或者取消定单', '库存不足', {
        confirmButtonText: '确定',
        type: 'warning',
      })
    },
    handleApplySend() {
      const id = this.$route.params.id
      o(`ProcurementApOrder(${id})/Services.RecheckProcurementApOrderAsync`).post().save().then((response) => {
        this.$message({
          message: '提交成功',
          type: 'success',
        })
        this.getDataForm()
      }).catch((err) => {
        this.lowStock(err)
      })
    },
  },
  components: {
    DetailPageLayout,
  },
}
</script>
<style lang="less">
.dispatch{
    padding: 20px 60px;
  .demo-table-expand label {
      width: 90px;
      color: #99a9bf;
    }
  .demo-table-expand {
    font-size: 0;
    padding-bottom:10px;
    margin-bottom:10px;
  }
  .demo-table-expand .el-form-item{
    margin-right: 0;
    margin-bottom: 0;
    margin-top:10px;
    width:20%;
    .el-form-item__content{
      line-height: 16px;
    }
  }
  .table-data{
    border-bottom: 1px solid #ccc;
  }
  .order-module{
    .demo-table-expand .el-form-item {
      width: 100%;
      .el-form-item__content{
        line-height: 36px;
      }
    }
  } 
  .status{
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// DispatchDetail_order.vue?ce35190c